import React from 'react';
import {
  EditPageContainer,
  Page,
  withServerErrors,
  withResolver,
} from 'components/common';
import { FormGroup, SaveButton, BackButton } from 'components/common/Forms';
import Select from 'react-select';
import RegionPriority from './RegionPriority';
import PostcodePriority from './PostcodePriority';
import { compose, withState } from 'recompose';
import { LocalForm, Control } from 'react-redux-form';

export const InstallerRuleEdit = ({
  mode,
  item,
  form,
  client,
  onBack,
  setDispatch,
  dispatch,
  onSubmit,
  onUpdate,
  onChange,
  installers,
  regions,
  region,
  setRegion,
  postcodes,
  postcode,
  setPostcode,
  renderServerError,
  readOnly,
}) => (
  <Page title={`${mode} Installer Rule for ${item.name}`}>
    <LocalForm
      initialState={item}
      onSubmit={onSubmit}
      getDispatch={setDispatch}
      onUpdate={onUpdate}
      onChange={onChange}
    >
      <FormGroup
          label="Primary Installer"
          model=".primary_installer"
          addControlClass={false}
      >
        <p style={{ fontSize: '0.8em' }}>
          If a Primary Installer is set for a country, it will override the
          auto-assigning of Imported Orders based on Region.
          <br />This will result in all <b>new</b> Orders inside that country
          being auto-assigned to the Primary Installer.
        </p>
        <Control.select
            model=".primary_installer"
            placeholder="Not Set"
            component={Select}
            simpleValue
            options={installers}
            labelKey="name"
            valueKey="id"
        />
      </FormGroup>
      <FormGroup
          label="Default Installer"
          model=".default_installer"
          addControlClass={false}
      >
        <p style={{ fontSize: '0.8em' }}>
          If a Default Installer is set for a country, it will assign to
          default installer if no other suitable installers are found.
        </p>
        <Control.select
            model=".default_installer"
            placeholder="Not Set"
            component={Select}
            simpleValue
            options={installers}
            labelKey="name"
            valueKey="id"
        />
      </FormGroup>
      <FormGroup
          label="Use Postcodes"
          model=".use_postcode"
          addControlClass={false}
      >
        <p style={{ fontSize: '0.8em' }}>
          Use postcodes instead of regions for auto-assigning for this country?
        </p>
        <Control.checkbox
            model=".use_postcode"
        />
      </FormGroup>
      <SaveButton className="float-right" form={form} hidden={readOnly} />
    </LocalForm>
    <div className="clearfix" />
    <FormGroup label="Regions">
      <Select
        placeholder="Select a region..."
        options={regions}
        labelKey="name"
        valueKey="id"
        value={region}
        onChange={val => {
          setRegion(val);
        }}
      />
    </FormGroup>
    {region && (
      <FormGroup label={`Installer Priorities for ${region.name}`}>
        <RegionPriority
          countryId={item.id}
          regionId={region.id}
          client={client}
        />
      </FormGroup>
    )}
    <FormGroup label="Postcodes">
      <Select
        placeholder="Select a postcode..."
        options={postcodes}
        labelKey="postcode"
        valueKey="id"
        value={postcode}
        onChange={val => {
          setPostcode(val);
        }}
      />
    </FormGroup>
    {postcode && (
      <FormGroup label={`Installer Priorities for ${postcode.postcode}`}>
        <PostcodePriority
          countryId={item.id}
          postcodeId={postcode.id}
          client={client}
        />
      </FormGroup>
    )}
    <BackButton className="float-right" onClick={onBack} />
  </Page>
);

const enhance = compose(
  withServerErrors(),
  EditPageContainer({
    url: 'installer-rules',
    convertServerErrors: ['password'],
  }),
  withState('serverErrors', 'setServerErrors', {}),
  withState('installers', 'setInstallers', []),
  withState('regions', 'setRegions', []),
  withState('postcodes', 'setPostcodes', []),
  withState('region', 'setRegion', null),
  withState('postcode', 'setPostcode', null),
  withResolver(
    {
      installers: ({ match }) => client =>
        client.get(`/countries/${match.params.id}/installers`),
    },
    {
      onResolved: ({ setInstallers }) => ({ installers }) => {
        setInstallers(
          installers.map(i => {
            return { ...i, name: i.name };
          })
        );
      },
    }
  ),
  withResolver(
    {
      regions: ({ match }) => client =>
        client.get(`installer-rules/${match.params.id}/regions`),
    },
    {
      onResolved: ({ setRegions, setRegion }) => ({ regions }) => {
        setRegions(regions);
        const hash = window.location.hash.replace('#', '');
        if (hash) {
          const regionId = parseInt(hash, 10);
          setRegion(regions.find(r => r.id === regionId));
        }
      },
    }
  ),
  withResolver(
    {
      postcodes: ({ match }) => client =>
          client.get(`installer-rules/${match.params.id}/postcodes`),
    },
    {
      onResolved: ({ setPostcodes, setPostcode }) => ({ postcodes }) => {
        setPostcodes(postcodes);
        const hash = window.location.hash.replace('#', '');
        if (hash) {
          const postcodeId = parseInt(hash, 10);
          setPostcode(postcodes.find(p => p.id === postcodeId));
        }
      },
    }
  )
);

export default enhance(InstallerRuleEdit);



// WEBPACK FOOTER //
// ./src/pages/InstallerRules/Edit.jsx